import { defineStore } from 'pinia'
import { ref } from 'vue'

/**
 * App Store — application-wide UI state.
 *
 * Responsibilities:
 * - Global loading indicator (consumed by api.ts interceptors)
 * - Global error message (consumed by api.ts interceptors)
 *
 * NOTE: Theme state lives in `stores/theme.ts` (useThemeStore).
 *       This store intentionally does NOT manage theme to avoid duplication.
 */
export const useAppStore = defineStore('app', () => {
  // State
  const isLoading = ref(false)
  const error = ref<string | null>(null)

  // Actions
  function setLoading(loading: boolean) {
    isLoading.value = loading
  }

  function setError(err: string | null) {
    error.value = err
  }

  return {
    // State
    isLoading,
    error,
    // Actions
    setLoading,
    setError
  }
}) 